const DepartmentDescTooltip = ({ desc = "" }: { desc?: string }) => {
  if (!desc) return null;
  return <span>: {desc}</span>;
};

export default DepartmentDescTooltip;
